import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
export default {
    isLogin: function() {
       console.log("check is login")
       // Cookie 认证（H5 原生登录）
       var ct0 = VueCookies.get("id")
       var st = VueCookies.get("_st")
       if (ct0 != undefined && st != undefined) {
         return true
       }
       // JWT 认证（微信小程序 web-view）
       try {
         var token = localStorage.getItem('wx_token')
         if (token) return true
       } catch (e) { /* localStorage 不可用时忽略 */ }
       return false
    }
}